import React, { Component } from "react";
import firebase from "../../utils/firebase";

import { FormSection, Field, FormFooter } from "@atlaskit/form";
import FieldTextStateless from "@atlaskit/field-text";
import Button from "@atlaskit/button";

import "./profileFormAddressAdd.css";

const initState = {
  address: "",
  from: "",
  to: "",
  landlordName: "",
  landlordTelephone: ""
};

const initError = {
  addressError: false,
  fromError: false,
  toError: false,
  landlordNameError: false,
  landlordTelephoneError: false
};
export default class ProfileFormAddressAdd extends Component {
  constructor(props) {
    super(props);

    this.state = { ...initState, ...initError };
  }

  fieldTextHandler = e =>
    this.setState({ [`${e.target.name}`]: e.target.value, ...initError });

  validate = () => {
    const { address, from, to, landlordName, landlordTelephone } = this.state;
    if (address.length === 0) return this.setState({ addressError: true });
    else if (from.length === 0) return this.setState({ fromError: true });
    else if (to.length === 0) return this.setState({ toError: true });
    else if (landlordName.length === 0)
      return this.setState({ landlordNameError: true });
    else if (landlordTelephone.length === 0)
      return this.setState({ landlordTelephoneError: true });
    else this.save();
  };

  save = () => {
    const { address, from, to, landlordName, landlordTelephone } = this.state;
    const addressId = firebase
      .firestore()
      .collection("my")
      .doc().id;
    firebase
      .firestore()
      .collection("my")
      .doc(this.props.userContext.user.uid)
      .update({
        [`addresses.${addressId}`]: {
          addressId,
          address,
          from,
          to,
          landlordName,
          landlordTelephone
        }
      })
      .then(() => this.props.handleAddAddressClick())
      .catch(error => console.log(error));
  };

  render() {
    console.log(this.state);
    return (
      <div className="profile-form__address-unit">
        <FormSection>
          <Field label="Address" isRequired isInvalid={this.state.addressError}>
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.address}
              name="address"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field label="From" isRequired isInvalid={this.state.fromError}>
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.from}
              name="from"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field label="To" isRequired isInvalid={this.state.toError}>
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.to}
              name="to"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Landlord Name"
            isRequired
            isInvalid={this.state.landlordNameError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.landlordName}
              name="landlordName"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Telephone"
            isRequired
            isInvalid={this.state.landlordTelephoneError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.landlordTelephone}
              name="landlordTelephone"
              isRequired
              shouldFitContainer
            />
          </Field>
        </FormSection>

        <FormFooter>
          <Button
            className="profile-form-address-add__button"
            onClick={this.validate}
            appearance="primary"
            type="submit"
          >
            Save
          </Button>
        </FormFooter>
      </div>
    );
  }
}

ProfileFormAddressAdd.defaultProps = {
  userContext: {
    user: {},
    my: {}
  }
};



// WEBPACK FOOTER //
// ./src/components/profileFormAddressAdd/ProfileFormAddressAdd.js